<toast-notification #toastNotification></toast-notification>

<div class="acs-toolbar-scroll">
  <div class="acs-toolbar">
    <div class="acs-flex acs-flex--center acs-gap-md">
      <div class="acs-flex acs-flex--center">
        <i class="fa-solid fa-building acs-dropdown__icon" title="Trade Unit"></i>
        <div class="acs-dropdown" (click)="$event.stopPropagation()">
        <button type="button" class="acs-dropdown__trigger" (click)="locDropdown.toggle()"
                [class.acs-dropdown__trigger--placeholder]="!locDropdown.selectedValue">
          {{locDropdown.displayText}}
          <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
        </button>
        <div class="acs-dropdown__panel" *ngIf="locDropdown.isOpen()">
          <input class="acs-dropdown__search" type="text" placeholder="Search..."
                 [ngModel]="locDropdown.searchText()" (ngModelChange)="locDropdown.searchText.set($event)"
                 (click)="$event.stopPropagation()" />
          <div class="acs-dropdown__options">
            <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                 (click)="selectLocOption(null)">-- Select Trade Unit --</div>
            <div *ngFor="let loc of locDropdown.filtered"
                 class="acs-dropdown__option"
                 [class.acs-dropdown__option--selected]="loc.value === locDropdown.selectedValue"
                 (click)="selectLocOption(loc)">{{loc.text}}</div>
            <div *ngIf="locDropdown.filtered.length === 0" class="acs-dropdown__empty">No matches</div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="acs-toolbar__actions" *ngIf="isDirty && locDropdown.selectedValue">
      <button class="acs-action-btn" (click)="cancelChanges()" [disabled]="isSaving">
        <i class="fa-solid fa-xmark"></i> Cancel
      </button>
      <button class="acs-action-btn acs-action-btn--accent" (click)="saveAll()" [disabled]="isSaving">
        <i class="fa-solid fa-floppy-disk"></i> Save
      </button>
    </div>
  </div>

  <!-- Form body -->
  <div *ngIf="locDropdown.selectedValue" class="loc-defaults-body">

    <!-- Confirmation Disclaimer (full width) -->
    <div class="acs-section">
      <div class="acs-section__title">Confirmation Disclaimer</div>
      <textarea class="acs-textarea"
                [(ngModel)]="form['ConfirmationDisclaimer']"
                (ngModelChange)="markDirty()"
                placeholder="Enter confirmation disclaimer text..."></textarea>
    </div>

    <!-- Two-column layout below disclaimer -->
    <div class="loc-defaults-layout">
    <div class="loc-defaults-col--main">

    <!-- Schedule -->
    <div class="acs-section">
      <div class="acs-section__title">Schedule</div>
      <div class="acs-row acs-mb-2">
        <div class="acs-col--md6">
          <label class="acs-label">Default Planning Window</label>
          <select class="acs-select"
                  [(ngModel)]="form['DefaultPlanningWindow']"
                  (ngModelChange)="markDirty()">
            <option value="">-- Select --</option>
            <option *ngFor="let opt of ['Today','Tomorrow','Yesterday','Current Week','Previous Week','Next Week','Current Month','Previous Month','Next Month','Custom']"
                    [value]="opt">{{opt}}</option>
          </select>
        </div>
        <div class="acs-col--md6">
          <label class="acs-label">Default Planning Perspective</label>
          <select class="acs-select"
                  [(ngModel)]="form['DefaultPlanningPerspective']"
                  (ngModelChange)="markDirty()">
            <option value="">-- Select --</option>
            <option value="Destination">Destination</option>
            <option value="Origin">Origin</option>
          </select>
        </div>
      </div>
      <label class="acs-checkbox-row">
        <input type="checkbox" [checked]="isChecked('ShowSchedulingByDay')"
               (change)="setChecked('ShowSchedulingByDay', $any($event.target).checked)">
        <span>Show Scheduling by Day</span>
      </label>
    </div>

    <!-- Dispatch -->
    <div class="acs-section">
      <div class="acs-section__title">Dispatch</div>

      <label class="acs-label acs-mb-2">Account Default</label>
      <div class="acs-radio-group acs-mb-3">
        <label class="acs-radio-row">
          <input type="radio" name="accountDefault" value="scoular"
                 [(ngModel)]="formAccountDefault" (ngModelChange)="markDirty()">
          <span>Default to "Scoular"</span>
        </label>
        <label class="acs-radio-row">
          <input type="radio" name="accountDefault" value="lastAccount"
                 [(ngModel)]="formAccountDefault" (ngModelChange)="markDirty()">
          <span>Last Account used on Schedule (Same Loc, Customer, Destination, Commodity)</span>
        </label>
      </div>

      <label class="acs-label acs-mb-2">Compuweigh</label>
      <label class="acs-checkbox-row acs-mb-3">
        <input type="checkbox" [checked]="isChecked('IsCompuweighEnabled')"
               (change)="setChecked('IsCompuweighEnabled', $any($event.target).checked)">
        <span>Enable Compuweigh for this trade unit</span>
      </label>

      <label class="acs-label acs-mb-2">OTC</label>
      <label class="acs-checkbox-row">
        <input type="checkbox" [checked]="isChecked('IsOTCEnabled')"
               (change)="setChecked('IsOTCEnabled', $any($event.target).checked)">
        <span>Enable</span>
      </label>
      <div *ngIf="isChecked('IsOTCEnabled')" class="acs-mt-1">
        <label class="acs-label">OTC Note</label>
        <input type="text" class="acs-input"
               [(ngModel)]="form['OTCNote']"
               (ngModelChange)="markDirty()"
               placeholder="Enter OTC note...">
      </div>

      <label class="acs-label acs-mb-2 acs-mt-3">Equipment</label>
      <label class="acs-checkbox-row">
        <input type="checkbox" [checked]="isChecked('ShowEquipmentFields')"
               (change)="setChecked('ShowEquipmentFields', $any($event.target).checked)">
        <span>Show Equipment Fields</span>
      </label>
    </div>

    <!-- Origin & Destination Confirmation (side by side) -->
    <div class="conf-columns">
      <div class="acs-section">
        <div class="acs-section__title">Origin Confirmation</div>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfBreakoutByDay')"
                 (change)="setChecked('OriginConfBreakoutByDay', $any($event.target).checked)">
          <span>Breakout by Day</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowPurchaseContract')"
                 (change)="setChecked('OriginConfShowPurchaseContract', $any($event.target).checked)">
          <span>Show Purchase Contract</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowTrucker')"
                 (change)="setChecked('OriginConfShowTrucker', $any($event.target).checked)">
          <span>Show Trucker</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowDest')"
                 (change)="setChecked('OriginConfShowDest', $any($event.target).checked)">
          <span>Show Destination</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowDestCityState')"
                 (change)="setChecked('OriginConfShowDestCityState', $any($event.target).checked)">
          <span>Show Destination City/ST</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowLoadNumbers')"
                 (change)="setChecked('OriginConfShowLoadNumbers', $any($event.target).checked)">
          <span>Show Load Numbers</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowDriverName')"
                 (change)="setChecked('OriginConfShowDriverName', $any($event.target).checked)">
          <span>Show Driver Name</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('OriginConfShowPlateNumber')"
                 (change)="setChecked('OriginConfShowPlateNumber', $any($event.target).checked)">
          <span>Show Plate Number</span>
        </label>
      </div>

      <div class="acs-section">
        <div class="acs-section__title">Destination Confirmation</div>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfBreakoutByDay')"
                 (change)="setChecked('DestConfBreakoutByDay', $any($event.target).checked)">
          <span>Breakout by Day</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfShowOrigin')"
                 (change)="setChecked('DestConfShowOrigin', $any($event.target).checked)">
          <span>Show Origin</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfShowTrucker')"
                 (change)="setChecked('DestConfShowTrucker', $any($event.target).checked)">
          <span>Show Trucker</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfUseDeliveryDate')"
                 (change)="setChecked('DestConfUseDeliveryDate', $any($event.target).checked)">
          <span>Use Delivery Date (Instead of Load Date)</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfShowUnloadNum')"
                 (change)="setChecked('DestConfShowUnloadNum', $any($event.target).checked)">
          <span>Show Unload #</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfHideUnassignedTrucker')"
                 (change)="setChecked('DestConfHideUnassignedTrucker', $any($event.target).checked)">
          <span>Hide Unassigned Truckers</span>
        </label>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('DestConfShowOriginCustomer')"
                 (change)="setChecked('DestConfShowOriginCustomer', $any($event.target).checked)">
          <span>Show Origin Customer</span>
        </label>
      </div>

      <div class="acs-section">
        <div class="acs-section__title">Trucker Confirmation</div>
        <label class="acs-checkbox-row">
          <input type="checkbox" [checked]="isChecked('BreakoutByDayOverride')"
                 (change)="setChecked('BreakoutByDayOverride', $any($event.target).checked)">
          <span>Breakout by Day Override</span>
        </label>
      </div>
    </div>

    </div><!-- /loc-defaults-col--main -->

    <!-- Right column: CompuWeigh Integration -->
    <div class="loc-defaults-col--side" *ngIf="isChecked('IsCompuweighEnabled')">
    <div class="acs-section">
      <div class="acs-section__title">Compuweigh</div>

      <table class="acs-table acs-table--bordered acs-table--striped acs-table--hover cw-table"
             *ngIf="compuweighEntries.length > 0">
        <thead class="acs-thead--primary">
          <tr>
            <th>Type</th>
            <th>Location</th>
            <th style="width: 48px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of compuweighEntries">
            <td>{{getEntryTypeDisplay(entry.key)}}</td>
            <td>{{getEntryLocationDisplay(entry)}}</td>
            <td class="acs-text-center">
              <button type="button"
                      class="acs-btn acs-btn--outline-danger acs-action-btn--sm"
                      title="Remove"
                      (click)="removeCompuweighEntry(entry)">
                <i class="fa-solid fa-trash-can"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="compuweighLoading" class="acs-text-muted acs-small acs-mt-1">
        Loading CompuWeigh sites...
      </div>

      <div *ngIf="!compuweighLoading && compuweighEntries.length === 0"
           class="acs-text-muted acs-small acs-mt-1">
        No CompuWeigh sites configured for this trade unit.
      </div>

      <!-- Add row -->
      <div class="cw-add-row acs-mt-2">
        <div class="cw-add-row__type">
          <select class="acs-select" [(ngModel)]="cwNewType" (ngModelChange)="clearCwLocation()">
            <option value="">-- Type --</option>
            <option value="CompuweighOriginID">Origin Site</option>
            <option value="CompuweighDestinationID">Destination Site</option>
          </select>
        </div>

        <div class="cw-add-row__location" (click)="$event.stopPropagation()">
          <div class="acs-dropdown acs-dropdown--full">
            <button type="button" class="acs-dropdown__trigger"
                    (click)="toggleCwLocationDropdown()"
                    [class.acs-dropdown__trigger--placeholder]="!cwNewLocationDisplay">
              {{cwNewLocationDisplay || '-- Select Location --'}}
              <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
            </button>
            <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('tud-cw-location')">
              <input class="acs-dropdown__search" type="text"
                     placeholder="Search by name (2+ chars, then Enter)..."
                     [ngModel]="cwLocationSearchText()"
                     (ngModelChange)="cwLocationSearchText.set($event)"
                     (click)="$event.stopPropagation()"
                     (keyup.enter)="searchCwLocations()" />
              <div class="acs-dropdown__options">
                <small *ngIf="cwIsSearching" class="acs-dropdown__empty">Searching...</small>
                <div *ngIf="cwLocationResults.length === 0 && !cwIsSearching"
                     class="acs-dropdown__empty">
                  Type 2+ chars and press Enter
                </div>
                <div *ngFor="let loc of cwLocationResults"
                     class="acs-dropdown__option"
                     [class.acs-dropdown__option--selected]="loc.locationId === cwNewLocationId"
                     (click)="selectCwLocation(loc)">
                  {{loc.locationCode}} — {{loc.locationName}}<span *ngIf="loc.city">, {{loc.city}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button"
                class="acs-action-btn acs-action-btn--accent"
                [disabled]="!cwCanAdd"
                (click)="addCompuweighEntry()">
          <i class="fa-solid fa-plus"></i> Add
        </button>
      </div>

      <div *ngIf="cwIsDuplicate" class="acs-text-danger acs-small acs-mt-1">
        This type + location combination already exists.
      </div>
    </div>
    </div><!-- /loc-defaults-col--side -->
    </div><!-- /loc-defaults-layout -->
  </div>

  <!-- Empty state -->
  <div *ngIf="!locDropdown.selectedValue" class="acs-table-wrap--connected acs-empty-state-wrap">
    <div class="acs-empty-state">
      <i class="fa-solid fa-sliders"></i>
      Select a trade unit to view defaults
    </div>
  </div>
</div>
